<template>
  <SwipeDialog
    class="doctor-list-selection-dialog"
    title="医生选择"
    @closeFn="$emit('close')"
  >
    <Tabs
      v-model="tabIndex"
      color="#aa341b"
      style="position: sticky; top: 0px; z-index: 9"
    >
      <Tab
        v-for="item in ['目标医生', '其他医生']"
        :key="item"
        :title="item"
      />
    </Tabs>
    <DoctorList
      v-if="tabIndex === 0"
      class="doctor-list-wrapper"
      :on-select-item="handleSelectItem"
      :selected-items="selectedIdList"
    />
    <DoctorListAll
      v-if="tabIndex === 1"
      class="doctor-list-wrapper"
      :on-select-item="handleSelectItem"
      :selected-items="selectedIdList"
      target-doctor-filter="false"
      @close="$emit('close')"
    />
    <van-button
      class="confirm-button"
      type="info"
      block
      @click="handleConfirm"
    >确定</van-button>
  </SwipeDialog>
</template>

<script>
import DoctorList from '@/components/DoctorTargetList.vue';
import DoctorListAll from './DoctorListAll.vue';
import SwipeDialog from '@/views/layout/swipeDialog';
import {Button, Tab, Tabs} from 'vant';
import Vue from 'vue';

Vue.use(Button);

export default {
  components: {
    DoctorList,
    SwipeDialog,
    DoctorListAll,
    Tab,
    Tabs,
  },
  props: {
    multipleMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
    defaultSelectedList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedList: [],
      tabIndex: 0,
    };
  },
  computed: {
    selectedIdList() {
      return this.selectedList?.map((item) => item.physician_id);
    },
  },
  created() {
    this.selectedList = this.defaultSelectedList;
  },
  methods: {
    handleConfirm() {
      this.$emit('select', this.selectedList);
    },
    handleSelectItem(item) {
      const id = item.physician_id;
      if (item.type === 'new') {
        this.selectedList.push(item);
        return;
      }
      if (this.multipleMode) {
        const selectedIndex = this.selectedList.findIndex(
          (item) => item.physician_id === id,
        );

        if (selectedIndex > -1) {
          this.selectedList.splice(selectedIndex, 1);
        } else {
          this.selectedList.push(item);
        }
      } else {
        this.selectedList = [item];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.doctor-list-selection-dialog ::v-deep .card-header-row {
  background: transparent !important;
  box-shadow: none !important;
}

.doctor-list-wrapper {
  padding-bottom: 56px;
}

.confirm-button {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
}
</style>
